import { useMemo } from 'react';
import { productAnalyticsService } from '../../services/analytics';

export enum FieldFillingType {
  Manual = 'manual',
  Auto = 'auto',
}

type FormChangedAnalyticsPayload = {
  param: string;
  value: string | boolean | number;
  fillingType: FieldFillingType;
};

type FormErrorAnalyticsPayload = {
  param: string;
  value?: string | boolean | number;
  error: string;
};

export const useFormAnalytics = () => {
  return useMemo(() => {
    return {
      logFormResetProductAnalytics: () =>
        productAnalyticsService.trackEvent({
          action: 'Click_sopr',
          label: 'deleteMortageParam',
        }),
      logFormExitProductAnalytics: () =>
        productAnalyticsService.trackEvent({
          action: 'Click_sopr',
          label: 'exit',
        }),
      logFormValueChangedProductAnalytics: ({ param, value, fillingType }: FormChangedAnalyticsPayload) =>
        productAnalyticsService.trackEvent({
          action: 'Click_sopr',
          label: param,
          extra: {
            paramValue: value,
            paramInput: fillingType,
          },
        }),
      logFormErrorProductAnalytics: ({ param, value, error }: FormErrorAnalyticsPayload) =>
        productAnalyticsService.trackEvent({
          action: 'Show_error',
          label: error,
          extra: {
            errorValue: value,
            errorField: param,
          },
        }),
    };
  }, []);
};
